import React, { useEffect, useState } from "react";
import CustomRichTextEditor from "../../../components/form/input/CustomRichTextEditor";
import { apiRequestWithAuth } from "../../../utils/api";
import Alert from "../../../components/ui/alert/Alert";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import ComponentCard from "../../../components/common/ComponentCard";
import Label from "../../../components/form/Label";
import Input from "../../../components/form/input/InputField";
import FileInput from "../../../components/form/input/FileInput";
import MyEditor5 from "../../../components/form/input/MyEditor5";
import {useNavigate} from "react-router-dom";

type SocialsFormData = {
    title: string;
    shortDescription: string;
    postContent: string;
    orderNo: number;
    type: number;
    files: { key: string; fileId: any }[];
    link: string;
};

const SocialsForm = () => {
    const defaultForm = {
        title: "",
        shortDescription: "",
        postContent: "",
        orderNo: 1,
        type: 5,
        files: [],
        link: ""
    };

    const [formData, setFormData] = useState<SocialsFormData>(defaultForm);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [preview, setPreview] = useState<string | null>(null);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const uploadFile = async (file: File) => {
        const formDataUpload = new FormData();
        formDataUpload.append("file", file);
        formDataUpload.append("id", "1");
        formDataUpload.append("subject", "quiz_cover");

        try {
            const res = await apiRequestWithAuth("/media/file", "POST", formDataUpload);
            return res.result?.id || null;
        } catch (error) {
            console.error("Upload failed", error);
            return null;
        }
    };

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setSelectedFile(file);
            setPreview(URL.createObjectURL(file));
            const uploadedId = await uploadFile(file);
            if (uploadedId) {
                setFormData(prev => ({
                    ...prev,
                    files: [
                        { key: "image", fileId: uploadedId }
                    ]
                }));
            }
        }
    };

    const handleSave = async () => {
        try {
            await apiRequestWithAuth("/media", "POST", formData);
            setOpenSnackbar(true);
            setFormData(defaultForm);
            setSelectedFile(null);
            setPreview(null);
            setTimeout(() => navigate("/socials"), 1000);
        } catch (error) {
            console.error("Failed to create social:", error);
        }
    };

    return (
        <div>
            {openSnackbar && (
                <Alert
                    variant="success"
                    title="Tạo social thành công"
                    message="Bạn đã tạo social mới thành công."
                />
            )}

            <PageMeta title="Tạo social" description="Trang tạo mới social" />
            <PageBreadcrumb pageTitle="Tạo social" />

            <div className="grid grid-cols-1 gap-6 xl:grid-cols-1">
                <div className="space-y-6">
                    <ComponentCard title="Thông tin social">
                        <div className="space-y-6">
                            <div>
                                <Label>Tiêu đề</Label>
                                <Input name="title" value={formData.title} onChange={handleChange} />
                            </div>

                            <div>
                                <Label>Mô tả ngắn</Label>
                                <Input name="shortDescription" value={formData.shortDescription} onChange={handleChange} />
                            </div>

                            <div>
                                <Label>Ảnh</Label>
                                <FileInput onChange={handleFileChange} />
                                {preview && (
                                    <img src={preview} alt="Preview" className="w-64 h-32 object-cover rounded border mt-2" />
                                )}
                            </div>

                            <div>
                                <Label>Nội dung</Label>
                                <MyEditor5
                                    content={formData.postContent}
                                    onBlur={(value) => handleChange({ target: { name: "postContent", value } } as any)}
                                />
                            </div>

                            <div>
                                <Label>Thứ tự</Label>
                                <Input
                                    name="orderNo"
                                    type="number"
                                    value={formData.orderNo}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </ComponentCard>
                </div>

                <button
                    onClick={handleSave}
                    className="mt-4 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition duration-300"
                >
                    Lưu social
                </button>
            </div>
        </div>
    );
};

export default SocialsForm;
